<template>
    <div class="resize-header">
        <p>
            Resize mode
            <span v-if="resizeDimensions">{{ resizeDimensions }}</span>
        </p>
        <Tooltip placement="left" :transfer="true">
            <hox-square-button @click="disableResize">
                <Icon size="24" type="ios-expand" />
            </hox-square-button>
            <template #content>Exit resize mode</template>
        </Tooltip>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        resizeDimensions: {
            type: String,
            default: ""
        }
    },

    emits: ["disableResize"],

    methods: {
        disableResize() {
            this.$emit("disableResize");
        }
    }
});
</script>

<style lang="scss" scoped>
.resize-header {
    display: flex;
    align-items: center;
    gap: 8px;
}
</style>
